import { useLanguage } from '../lib/i18n/LanguageContext';
import { useTheme } from '../lib/theme';

/**
 * Half-pill theme slider — same markup, icons and click semantics as
 * llmr-website's header toggle (Base.astro). One click flips light ↔ dark;
 * the sliding knob and moon/sun artwork are driven by `data-theme` on
 * `<html>`, with motion gated by the `theme-motion` class (see theme.tsx /
 * index.html) so the first paint never animates from the wrong side.
 */
export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const { dict } = useLanguage();
  const label = theme === 'dark' ? dict.themeToggle.toLight : dict.themeToggle.toDark;

  return (
    <button type="button" className="theme-toggle" onClick={toggle} aria-label={label} title={label}>
      <span className="theme-toggle-track" aria-hidden="true">
        <span className="theme-toggle-thumb">
          <svg className="theme-toggle-knob theme-toggle-knob-moon" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M20.5 13.2A8.5 8.5 0 1 1 10.8 3.5a7 7 0 0 0 9.7 9.7Z" fill="currentColor" />
          </svg>
          <svg className="theme-toggle-knob theme-toggle-knob-sun" viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="12" cy="12" r="4" fill="currentColor" />
            <circle cx="12" cy="4.2" r="1.6" fill="currentColor" />
            <circle cx="12" cy="19.8" r="1.6" fill="currentColor" />
            <circle cx="4.2" cy="12" r="1.6" fill="currentColor" />
            <circle cx="19.8" cy="12" r="1.6" fill="currentColor" />
            <circle cx="6.1" cy="6.1" r="1.6" fill="currentColor" />
            <circle cx="17.9" cy="17.9" r="1.6" fill="currentColor" />
            <circle cx="17.9" cy="6.1" r="1.6" fill="currentColor" />
            <circle cx="6.1" cy="17.9" r="1.6" fill="currentColor" />
          </svg>
        </span>
        <svg className="theme-toggle-bg theme-toggle-bg-moon" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M20.5 13.2A8.5 8.5 0 1 1 10.8 3.5a7 7 0 0 0 9.7 9.7Z" fill="currentColor" />
        </svg>
        <svg className="theme-toggle-bg theme-toggle-bg-sun" viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="12" r="4" fill="currentColor" />
          <circle cx="12" cy="4.2" r="1.6" fill="currentColor" />
          <circle cx="12" cy="19.8" r="1.6" fill="currentColor" />
          <circle cx="4.2" cy="12" r="1.6" fill="currentColor" />
          <circle cx="19.8" cy="12" r="1.6" fill="currentColor" />
          <circle cx="6.1" cy="6.1" r="1.6" fill="currentColor" />
          <circle cx="17.9" cy="17.9" r="1.6" fill="currentColor" />
          <circle cx="17.9" cy="6.1" r="1.6" fill="currentColor" />
          <circle cx="6.1" cy="17.9" r="1.6" fill="currentColor" />
        </svg>
      </span>
    </button>
  );
}
